import {
	IMobileSdkTestIssue,
	TMobileSdkTestAllIssuesResult
} from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import { formatDate } from 'src/common/helpers/DateFormatHelper';
import {
	buildBoundingBox,
	buildElementInfo,
	MOBILE_SEVERITY_MAP
} from 'src/common/helpers/MobileQueriesHelper';

import { MobileSdkTestIssuesQuery } from '../MobileSdkTestIssues.generated';

const transformIssueToTestIssue = (
	issue: NonNullable<NonNullable<MobileSdkTestIssuesQuery['issues']>[0]>
): IMobileSdkTestIssue => {
	const elementInfo = buildElementInfo(issue);
	const boundingBox = buildBoundingBox(issue);

	return {
		id: issue.issue_id,
		type: issue.type_name,
		severity: MOBILE_SEVERITY_MAP[issue.severity_name],
		runTime: formatDate(issue.run_time),
		scanName: issue.scan_name ?? 'Scan 1',
		shortNodeId: issue.elements__index[0] ?? '1',
		elementInfo,
		screenshotUrl: issue.screenshot,
		boundingBox,
		viewportWidth: issue.viewport_width,
		viewportHeight: issue.viewport_height
	};
};

export const transformMobileSdkTestIssuesResults = (
	rawResults: MobileSdkTestIssuesQuery
): TMobileSdkTestAllIssuesResult => {
	const rows: IMobileSdkTestIssue[] =
		rawResults.issues?.filter(returnNonNull).map(transformIssueToTestIssue) ?? [];

	let total = 0;
	if (rawResults.total?.length) {
		total = rawResults.total[0]?.issue_id_count ?? 0;
	}

	let unfilteredTotal = 0;
	if (rawResults.unfiltered_total?.length) {
		unfilteredTotal = rawResults.unfiltered_total[0]?.issue_id_count ?? 0;
	}

	return {
		rows,
		total,
		unfilteredTotal
	};
};
